<template lang="pug">
#nickname.modal.modal-bottom.fade.modal-common(tabindex='-1' role='dialog' aria-labelledby='nicknameLabel' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.modal-bottom-center(role='document')
    .modal-content
      .modal-header
        .icon(data-bs-dismiss='modal' aria-label='Close')
          i.fas.fa-arrow-left
        h5.modal-title {{ $t("ui.set_nickname") }}
      .modal-body
        .setting
          .form-group.mb-0
            input.form-control(type="text" v-model="nickName" id="" placeholder="")
            small.form-text.text-danger.w-75(v-if="feedback.nickName") {{ feedback.nickName }}
            .text-small {{ $t("message.nickname_rule") }}
          .btn-wrapper.mt-2
            .btn-cancel(data-bs-dismiss='modal' aria-label='Close') {{ $t("ui.cancel") }}
            SpinButton(type="button" @click="submit" :loading="loading" css="btn-confirm" :text="$t('ui.save')")

</template>

<script>
import SpinButton from "@/components/ui/SpinButton";
import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
import errors from "@/errors";
import service from "@/library/_xhr-account";

export default {
  components: {
    SpinButton
  },
  data: () => ({
    loading: false,
    nickName: "",
    feedback: {
      success: false,
      status: errors.request.failed,
      nickName: "",
      timeout: null
    }
  }),
  validations: {
    nickName: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(15)
    }
  },
  mounted() {
    $(this.$refs.nickname).on("hidden.bs.modal", this.onClose);
  },
  methods: {
    resetFeedback() {
      this.feedback.nickName = "";
    },
    clearInput() {
      this.nickName = "";
    },
    onClose() {
      this.clearInput();
      this.resetFeedback();
    },
    submit() {
      if (this.validate()) {
        this.addSecondary();
      }
    },
    validate() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        return true;
      } else {
        this.loading = false;
        this.resetFeedback();
        clearTimeout(this.feedback.timeout);

        if (!this.$v.nickName.required) {
          this.feedback.nickName = this.$t("error.nickNameRequired");
        }

        if (!this.$v.nickName.alphaNum) {
          this.feedback.nickName = this.$t("error.alphaNumOnly");
        }

        if (!this.$v.nickName.minLength) {
          this.feedback.nickName = this.$t("error.isMinValue", {"fname": this.$t("ui.nickname"), "fvalue":"6"});
        }

        if (!this.$v.nickName.maxLength) {
          this.feedback.nickName = this.$t("error.isMaxValue", {"fname": this.$t("ui.nickname"), "fvalue":"15"});
        }

        this.feedback.timeout = setTimeout(() => {
          this.$v.$reset();
          this.resetFeedback();
        }, 10000);
      }

      return false;
    },
    addSecondary() {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        new_account_id: this.nickName
      };

      this.loading = true;
      service.addSecondary(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.clearInput();
              this.$v.$reset();
              this.$store.dispatch("user/reLogin").then(
                res => {
                  this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
                },
                err => {
                  this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
                }
              );
              // this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
            } else {
              this.$store.dispatch("user/reLogin").then(
                res => {
                  this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
                },
                err => {
                  this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
                }
              );
              // this.$helpers.handleFeedback(this.feedback.status);
            }
            $('#nickname').modal('hide');
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    }
  }
}
</script>